import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';

export const roundInventoryQualityScore = (value: number): number => Math.round(value);

export const formatInventoryQualityScore = (value: number | null | undefined, nullValue = 'N/A'): string =>
  abbreviateNumericValue(value == null ? value : roundInventoryQualityScore(value), {
    allowZero: true,
    nullValue,
    decimalPlaces: 0,
  });
